import { UPDATE_FOLDER_NAME } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_FOLDER_NAME.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_FOLDER_NAME.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_FOLDER_NAME.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
